import React from "react";
import {Spin} from "antd";

export default function FSLoginHandler() {
    return <div className={'flex w-full h-100vh justify-center items-center'}>
        <div className={'flex justify-center items-center'}>
            跳转中
            <Spin className={'ml-2'}/>
        </div>
    </div>
}